import { render, staticRenderFns } from "./ImpersonateBar.vue?vue&type=template&id=0648f573&scoped=true&"
import script from "./ImpersonateBar.vue?vue&type=script&lang=ts&"
export * from "./ImpersonateBar.vue?vue&type=script&lang=ts&"
import style0 from "./ImpersonateBar.vue?vue&type=style&index=0&id=0648f573&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0648f573",
  null
  
)

export default component.exports